// EINZIGE Stelle fuer die Store-Download-Links auf der Webseite.
// Leerer String ('') => der Button wird als "Bald verfuegbar" angezeigt (kein toter Link).

// iOS: seit dem 10. September 2026 oeffentlich im App Store. Loest den frueheren
// TestFlight-Link ab — TestFlight bleibt der Weg fuer Vorab-Builds, gehoert damit
// aber nicht mehr auf die oeffentliche Seite.
// Das '/de/' muss drin bleiben: ohne Laenderkuerzel antwortet Apple mit 404
// (geprueft am 10.09.2026), erst /de/ leitet auf die Produktseite weiter.
export const APP_STORE_URL = 'https://apps.apple.com/de/app/eachotter/id6759525374';

// Android: Bis Google den Produktionszugriff erteilt, ist die App nur im
// geschlossenen Play-Test (Track alpha). Der Knopf führt deshalb auf die eigene
// Seite /android, die den Weg in drei Schritten erklärt:
//   1. Der Google Group „EachOtter-Tester“ beitreten (ANDROID_BETA_GROUP_URL).
//      Seit 20.10.2026 hängt der geschlossene Test an dieser Gruppe, und ihr kann
//      jede:r selbst beitreten („Jeder im Web kann beitreten“).
//   2. Über den Testlink „Tester werden“ (PLAY_TEST_URL). Der funktioniert erst
//      nach dem Beitritt, vorher meldet Google „nicht berechtigt“.
//   3. Die App im Play Store installieren (PLAY_STORE_LISTING_URL).
// Vorher zeigte der Knopf auf Firebase App Distribution. Das ist abgelöst, weil
// Firebase in Schulnetzen oft blockiert ist und Firebase-Installationen nicht für
// Googles Vorgabe vor dem Produktionszugriff zählen (12 Tester:innen, 14 Tage im
// geschlossenen Test). Auch der Android-Workflow verteilt nicht mehr über Firebase.
//
// Umstellung nach der Produktionsfreigabe (ein Schritt, beides zusammen ändern):
//   PLAY_STORE_URL = PLAY_STORE_LISTING_URL
//   PLAY_STORE_LABEL = { top: 'Jetzt bei', bottom: 'Google Play' }
// Die Seite /android dann auf den Store-Eintrag umschreiben oder weiterleiten,
// weil gedruckte Links und QR-Codes auf eachotter.de/android zeigen.
export const ANDROID_BETA_GROUP_URL = 'https://groups.google.com/g/eachotter-tester';
export const PLAY_TEST_URL = 'https://play.google.com/apps/testing/de.eachotter.app'; // erst nach dem Gruppenbeitritt
export const PLAY_STORE_LISTING_URL = 'https://play.google.com/store/apps/details?id=de.eachotter.app';
export const ANDROID_BETA_PAGE = '/android';
export const PLAY_STORE_URL = ANDROID_BETA_PAGE;

// Beschriftung der Knoepfe (top = kleine Versalzeile, bottom = grosse Zeile).
// Immer zusammen mit der URL aendern. „Google Play“ auf einem Knopf, der erst zu
// einer Anleitung führt, wäre ein Versprechen, das die Seite nicht einlöst.
export const APP_STORE_LABEL = { top: 'Laden im', bottom: 'App Store' };
export const PLAY_STORE_LABEL = { top: 'Offene Beta', bottom: 'Für Android' };

// Play-Dreieck nur zeigen, wenn der Knopf wirklich zu Google Play fuehrt.
export const isPlayStoreLink = (url) => /^https:\/\/play\.google\.com\//.test(url || '');

// Interner Pfad der eigenen Website (z. B. /android) statt einer fremden Adresse.
export const isInternalLink = (url) => /^\/(?!\/)/.test(url || '');

// Prueft, ob ein Link gesetzt und kein Platzhalter ist.
export const isLinkReady = (url) => Boolean(url) && url !== '#';
